import React, { Component } from 'react';
import PropTypes from 'prop-types';
import translate from 'components/hoc/translate';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { fetchInvoices } from 'http/requests/invoicesRequests';
import ComputedPriceField from 'components/show/ComputedPriceField';
import TableBodyCell from 'components/table/TableBodyCell';
import CardText from 'components/ui/card/CardText';
import Pagination from 'components/list/Pagination/Pagination';
import TextField from 'components/show/TextField';
import TableRow from 'components/ui/table/TableRow';
import HeaderColumn from 'components/ui/table/HeaderColumn';
import Table from 'components/ui/table/Table';
import styled from 'styled-components';
import DateTextField from 'components/show/DateFields/DateTextField';
import StatusTextField from 'components/show/StatusTextField';
import Loader from 'components/loading/Loader';
import InvoiceStatus from '../show/InvoiceStatus';

const ListStylingWrapper = styled.div`
    position: relative;
`;

const LoaderStylingWrapper = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FFF;
    opacity: .9;
    z-index: 999;
    pointer-events: none;
`;

const LoaderStylingBlock = styled.div`
    margin-top: 50px;
    display: flex;
    width: 150px;
    height: 150px;
    justify-content: center;
    align-items: center;
    opacity: 1;
`;

class InvoicesTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            data: [],
            page: 1,
            offset: 0,
            sortDirection: props.order,
            total: 0,
        };
    }

    componentDidMount() {
        this.refreshData();
    }

    refreshData = async () => {
        const {
            field,
            params,
            size = 24,
        } = this.props;

        const {
            offset,
            sortDirection,
        } = this.state;

        this.setState({
            loading: true,
        });

        try {
            const response = await fetchInvoices({
                ...params,
                sort_by: field,
                sort_direction: sortDirection,
                size,
                offset,
            });

            this.setState({
                loading: false,
                data: response.results,
                total: response.total,
            });
        } catch (error) {
            this.setState({
                loading: false,
            });
        }
    }

    setPage = (page) => {
        if (page === this.state.page) {
            return;
        }

        this.setState({
            page,
            offset: (page - 1) * this.props.size,
        }, () => {
            this.refreshData();
        });
    }

    render() {
        const { history, size, translate } = this.props;
        const { data, loading, offset, page, total } = this.state;

        if (loading) {
            return (
                <LoaderStylingWrapper>
                    <LoaderStylingBlock>
                        <Loader />
                    </LoaderStylingBlock>
                </LoaderStylingWrapper>
            );
        }

        if (total === 0) {
            return (
                <ListStylingWrapper>
                    <CardText style={ { padding: '20px' } }>
                        { translate('aor.navigation.no_results') }
                    </CardText>
                </ListStylingWrapper>
            );
        }

        return (
            <ListStylingWrapper>
                <Table responsive='scroll'>
                    <TableRow>
                        <HeaderColumn style={ { width: '30%' } }>
                            { translate('resources.products.fields.id') }
                        </HeaderColumn>
                        <HeaderColumn style={ { width: '30%' } }>
                            { translate('resources.invoices.fields.invoiced_at') }
                        </HeaderColumn>
                        <HeaderColumn style={ { width: '30%' } }>
                            { translate('resources.invoices.fields.status') }
                        </HeaderColumn>
                        <HeaderColumn style={ { width: '10%' } }>{ translate('resources.invoices.fields.amount') }</HeaderColumn>
                    </TableRow>

                    { data.map((invoice) => {
                        return (
                            <TableRow
                                key={ invoice.id }
                                onClick={ () => {
                                    history.push(`/invoices/${ invoice.id }/show`);
                                } }
                            >
                                <TableBodyCell
                                    field={ <TextField column value={ invoice.id } /> }
                                    record={ invoice }
                                    source='id'
                                />

                                <TableBodyCell
                                    field={ <DateTextField label='' value={ invoice.invoiced_at } /> }
                                    record={ invoice }
                                    source='invoiced_at'
                                />
                                <TableBodyCell
                                    field={ <StatusTextField component={ InvoiceStatus } value={ invoice.status } /> }
                                    record={ invoice }
                                    source='status'
                                />
                                <TableBodyCell
                                    field={ <ComputedPriceField value={ invoice.amount } /> }
                                    record={ invoice }
                                    source='amount'
                                />
                            </TableRow>
                        );
                    }) }
                </Table>

                <Pagination
                    currentPage={ page }
                    offset={ offset }
                    setPage={ this.setPage }
                    size={ size }
                    total={ total }
                />
            </ListStylingWrapper>
        );
    }
}

InvoicesTable.propTypes = {
    field: PropTypes.string,
    history: PropTypes.object.isRequired,
    order: PropTypes.string,
    params: PropTypes.shape({
        category_id: PropTypes.arrayOf(PropTypes.number),
        id: PropTypes.arrayOf(PropTypes.number),
        invoiced_at: PropTypes.string,
        user_id: PropTypes.number,
        status: PropTypes.string,
        subcategory_id: PropTypes.arrayOf(PropTypes.number),
    }).isRequired,
    size: PropTypes.oneOf([
        12,
        24,
        48,
        96,
    ]),
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    return {
        field: state.invoices.field,
        order: state.invoices.order,
        size: props.size || state.invoices.size,
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        null,
    ),
    translate,
);

export default enhance(InvoicesTable);



// WEBPACK FOOTER //
// ./src/pages/invoices/list/InvoicesTable.js